import { ApolloError } from '@apollo/client'
import { useMemo } from 'react'

type Props = {
  error?: ApolloError | null
  messageTranslations?: Record<string, string>
}

export function ApolloErrorMessage({ error, messageTranslations }: Props) {
  const messages = useMemo(() => {
    if (!error) return []

    if (error.graphQLErrors) {
      return error.graphQLErrors.map(error => error.message)
    }

    return [error.message]
  }, [error])

  if (!error) return null

  return (
    <div className="flex flex-col gap-1">
      {messages.map(function (msg, idx) {
        return (
          <span
            className="pl-2 text-regular text-red-500"
            role="alert"
            key={idx}
          >
            {messageTranslations?.[msg] ?? msg}
          </span>
        )
      })}
    </div>
  )
}
